import type { StreamContribution } from '@wehunt/app-shell-web'
import { buildCampfireRoutes, type CampfireRouteOptions } from './routes'

/**
 * Campfire's contribution to the WeHunt web shell.
 *
 * Routes only, and no nav item: the replay is reached from a hunt, never from the
 * sidebar — there is nothing to show at `/replay` without a hunt id.
 *
 * A factory because the share link domains are the shell's runtime configuration,
 * and a domain importing the shell's config would invert the dependency: the shell
 * resolves them and hands campfire plain values.
 */
export function createCampfireContribution(options: CampfireRouteOptions = {}): StreamContribution {
  return {
    id: 'campfire',
    routes: (rootRoute) => buildCampfireRoutes(rootRoute, options),
  }
}
